// Create redux store with history

import configureStore from '../configureStore';

const initialState = {};
const storeApp = configureStore(initialState);
export default storeApp;
